<script lang="ts" setup>
import type { ApiFaqDetail } from '~~/server/api/faq/[slug]'

/* eslint-disable vue/no-v-html */
definePageMeta({
    layout: false,
})
const route = useRoute()
const { $t } = useNuxtApp()

const { data: page, redirect } = await useFetchWithRedirect<ApiFaqDetail>(
    `/api/faq/${route.params.id}`,
    { route }
)

if(redirect && !redirect?.error) {
    navigateTo(redirect.data.url, redirect.data.options)
}

const breadcrumbs = computed<BreadcrumbsLink[]>(() => {
    const data: BreadcrumbsLink[] = [
        {
            name: 'Často kladené otázky',
            slug: useNamedRoutes({ name: 'faq' }),
        },
    ]

    page.value?.data.breadcrumbs.map((link: BreadcrumbsLink): void => {
        const linkItem: BreadcrumbsLink = {
            name: link.name,
            slug: useNamedRoutes({
                name: 'faq-category',
                params: { id: link.slug },
            }),
        }

        data.push(linkItem)
    })

    return data
})

// Page meta
usePageMeta({
    meta: page.value?.data.meta,
    title: page.value?.data.title,
})

if (route.params.id) {
    useCanonicalHead({ routeName: useNamedRoutes({ name: 'faq-category', params: { id: route.params.category } }) })
}
</script>
<template>
  <div v-if="page">
    <NuxtLayout
      name="faq"
      current="xyz"
    >
      <template #page-header>
        <PagesFaqPageHeader
          :title="$t('S čím potrebujete pomôcť?')"
          :headline="page.data.headline"
          heading-type="h1"
        />
      </template>
      <article>
        <h2 class="beta mb-8">
          {{ page.data.title }}
        </h2>
        <Typo>
          <div v-html="page.data.description" />
        </Typo>
        <section
          v-if="
            page.data.documents &&
              page.data.documents.data.length > 0
          "
          class="mt-8"
        >
          <h3 class="delta mb-4">
            {{ page.data.documents.title }}
          </h3>
          <LazyDocumentsTableSimple
            :data="page.data.documents.data"
            :caption="page.data.documents.title"
          />
        </section>
      </article>
      <template #aside>
        <Tracker :data="{ position: page.data.title }">
          <PagesFaqDetailMenu :data="page.data.faq_list" />
        </Tracker>
      </template>
      <template #breadcrumbs>
        <Breadcrumbs
          :links="breadcrumbs"
          :current="page.data.title"
          class="mt-0"
        />
      </template>
    </NuxtLayout>
  </div>
</template>
